const vars = window.DP_ENV || {}

const env = {
  URL_API: vars.URL_API || "http://example.com/wp-json/dp/v1",
  URL_AUTH: vars.URL_AUTH || "http://example.com/wp-json/jwt-auth/v1",
  URL_REGISTER: vars.URL_REGISTER || false, // string | false
  URL_OAUTH: vars.URL_OAUTH || "https://example.com/?option=oauthredirect&app_name=SERVICE&redirect_uri=http%3A%2F%2Fexample.com%2F",
  ENABLE_MATOMO_TRACKING: vars.ENABLE_MATOMO_TRACKING || false, // bool
  DEBUG_LOGIN: vars.DEBUG_LOGIN || false,
  TRACKING_INSTRUMENTATION_KEY: vars.TRACKING_INSTRUMENTATION_KEY || false, // string | false
  TRACKING_CONFIG: vars.TRACKING_CONFIG || false, // object | false
  HIDE_LANGSWITCH: vars.HIDE_LANGSWITCH || false, // bool
  LANGUAGES: vars.LANGUAGES || ["de", "en"], // array<string> – available languages: de, en
  DISABLE_LEARNING: vars.DISABLE_LEARNING || false, // bool
  DISABLE_COMMENTS: vars.DISABLE_COMMENTS || false, // bool
  DISABLE_PRINTING: vars.DISABLE_PRINTING || false, // bool
  SHOW_CERTIFICATE_VALIDATION: vars.SHOW_CERTIFICATE_VALIDATION || false, // bool
  DISABLE_LEARNING_TAGS: vars.DISABLE_LEARNING_TAGS || false, // bool
  DISABLE_FAQ_FLYOUT: vars.DISABLE_FAQ_FLYOUT || false, // bool
  CONTACT_MAIL_ADDRESS: vars.CONTACT_MAIL_ADDRESS || "mail@example.com", // string
  DISABLE_NOTIFICATIONS: vars.DISABLE_NOTIFICATIONS || false, // bool
  DISABLE_NOTIFICATIONS_MAIL_SETTING: vars.DISABLE_NOTIFICATIONS_MAIL_SETTING || false, // bool
  SITE_NAME: vars.SITE_NAME || "abat+ Lernplattform", // string
  QUIZ_MAX_FAILURES: vars.QUIZ_MAX_FAILURES || 0.33 // float,
}

export default env



// WEBPACK FOOTER //
// ./src/env.js